import { useProductItemContext } from '@app/components/products/context/ProductItemContext';
import { useGallery } from '@app/utils/hooks/useGallery';

import { GallerySlide } from './GallerySlide';
interface Props {
  isCompact?: boolean;
  overlapHeight?: number;
  parentWidth: number;
  isDisabled?: boolean;
  shouldSlideUpOnHover?: boolean;
  className?: string;
}
export const Gallery = ({
  isCompact = false,
  overlapHeight = 0,
  parentWidth,
  isDisabled = false,
  className,
  shouldSlideUpOnHover = false,
}: Props) => {
  const { activeSlideIndex, gallerySlides, setActiveSlideIndex } = useProductItemContext();

  const { ref } = useGallery({
    activeIndex: activeSlideIndex,
    onChange: setActiveSlideIndex,
    orientation: 'horizontal',
  });

  return (
    <>
      <div
        ref={ref}
        className="flex snap-x snap-mandatory gap-px overflow-x-hidden overscroll-x-none no-scrollbar touch:overflow-x-auto"
        {...(isDisabled ? { inert: '' } : undefined)}
      >
        {gallerySlides.map((slide, index) => (
          <GallerySlide
            key={slide.id}
            isActive={activeSlideIndex === index}
            image={slide.image}
            variant={slide.variant}
            isCompact={isCompact}
            overlapHeight={overlapHeight}
            parentWidth={parentWidth}
            imageClassName={className}
            shouldSlideUpOnHover={shouldSlideUpOnHover}
          />
        ))}
      </div>
    </>
  );
};
